// extracted by mini-css-extract-plugin
export default {"content":"CardCategory_content__X9OER","name":"CardCategory_name__6A8RF","qty":"CardCategory_qty__3lwQh"};